import React from 'react'
import Icon from '@ant-design/icons'

const ClientNoteSvgIcon = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      opacity="0.1"
      cx="18.6348"
      cy="18.0001"
      rx="18"
      ry="17.9999"
      fill="#75879D"
    />
    <path
      d="M24.4444 13.5558V20.5558H20.5556V24.4447H13.5556V13.5558H24.4444ZM24.4444 12.0002H13.5556C12.7 12.0002 12 12.7002 12 13.5558V24.4447C12 25.3002 12.7 26.0002 13.5556 26.0002H21.3333L26 21.3336V13.5558C26 12.7002 25.3 12.0002 24.4444 12.0002ZM19 20.5558H15.1111V19.0002H19V20.5558ZM22.8889 17.4447H15.1111V15.8891H22.8889V17.4447Z"
      fill="#264382"
    />
  </svg>
)

export const ClientNoteIcon = (props) => (
  <Icon component={ClientNoteSvgIcon} {...props} />
)

const ClientMsgSvgIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="37" height="36" fill="none">
    <circle cx="18.268" cy="18" r="18" fill="#75879D" opacity=".1" />
    <mask id="cicly-mask-a123" fill="#fff">
      <path d="M11.98 21.571a7 7 0 1 1 2.449 2.45l-2.419.69a.584.584 0 0 1-.721-.721l.69-2.419Z" />
    </mask>
    <path
      fill="#264382"
      d="m11.98 21.571-1.29.765a1.5 1.5 0 0 0 2.79-.765h-1.5Zm2.449 2.45h-1.5c0 .529.279 1.02.734 1.29l.766-1.29Zm0 0h1.5a1.5 1.5 0 0 0-1.912-1.443l.412 1.442Zm-2.419.69-.412-1.442.412 1.442Zm-.721-.721 1.442.412-1.442-.412Zm.69-2.419h1.5a1.5 1.5 0 0 0-2.942-.412l1.442.412Zm1.29-.765a5.5 5.5 0 0 1-.673-3.831l-2.947-.56a8.5 8.5 0 0 0 1.04 5.922l2.58-1.531Zm-.673-3.831a5.5 5.5 0 0 1 2.03-3.319l-1.84-2.369a8.5 8.5 0 0 0-3.137 5.129l2.947.559Zm2.03-3.319a5.5 5.5 0 0 1 3.718-1.145l.187-2.994a8.5 8.5 0 0 0-5.745 1.77l1.84 2.37Zm3.718-1.145a5.5 5.5 0 0 1 3.545 1.6l2.122-2.121a8.5 8.5 0 0 0-5.48-2.473l-.187 2.994Zm3.545 1.6a5.5 5.5 0 0 1 1.6 3.546l2.994-.188a8.5 8.5 0 0 0-2.473-5.48l-2.12 2.122Zm1.6 3.546a5.5 5.5 0 0 1-1.146 3.717l2.37 1.84a8.5 8.5 0 0 0 1.77-5.745l-2.994.188Zm-1.146 3.717a5.5 5.5 0 0 1-3.318 2.03l.56 2.947a8.5 8.5 0 0 0 5.128-3.137l-2.37-1.84Zm-3.318 2.03a5.5 5.5 0 0 1-3.831-.674l-1.53 2.58a8.5 8.5 0 0 0 5.92 1.041l-.559-2.947Zm-3.096.616h-3 3Zm-1.912-1.442-2.42.691.825 2.885 2.419-.691-.824-2.885Zm-2.42.691a.916.916 0 0 1 .482-.006l-.752 2.904c.36.093.738.089 1.095-.013l-.824-2.885Zm.482-.006a.916.916 0 0 1 .419.24l-2.122 2.12c.263.263.591.45.951.544l.752-2.904Zm.419.24c.115.115.198.26.239.417l-2.904.753c.093.36.28.688.543.95l2.122-2.12Zm.239.417a.917.917 0 0 1-.006.482l-2.885-.824a2.083 2.083 0 0 0-.013 1.095l2.904-.753Zm-.006.482.69-2.419-2.884-.824-.69 2.419 2.884.824Zm-2.252-2.83h3-3Z"
      mask="url(#cicly-mask-a123)"
    />
    <path
      fill="#264382"
      d="M17.935 18.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615ZM14.433 18.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615ZM21.435 18.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615Z"
    />
  </svg>
)

export const ClientMsgIcon = (props) => (
  <Icon component={ClientMsgSvgIcon} {...props} />
)

const ClientUnreadMsgSvgIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none">
    <circle cx="18" cy="18" r="18" fill="#75879D" opacity=".1" />
    <mask id="a" fill="#fff">
      <path d="M10.98 22.571a7 7 0 1 1 2.449 2.45l-2.419.69a.584.584 0 0 1-.721-.721l.69-2.419Z" />
    </mask>
    <path
      fill="#264382"
      d="m10.98 22.571 1.442.412a1.5 1.5 0 0 0-.152-1.177l-1.29.765Zm2.449 2.45.765-1.29a1.5 1.5 0 0 0-1.178-.153l.413 1.442Zm-2.419.69-.412-1.442.412 1.442Zm-.721-.721 1.442.412-1.442-.412Zm1.98-3.184a5.5 5.5 0 0 1-.673-3.831l-2.947-.56a8.5 8.5 0 0 0 1.04 5.922l2.58-1.531Zm-.673-3.831a5.5 5.5 0 0 1 2.03-3.319l-1.84-2.369a8.5 8.5 0 0 0-3.137 5.129l2.947.559Zm2.03-3.319a5.5 5.5 0 0 1 3.718-1.145l.187-2.994a8.5 8.5 0 0 0-5.745 1.77l1.84 2.37Zm3.718-1.145a5.5 5.5 0 0 1 3.545 1.6l2.122-2.121a8.5 8.5 0 0 0-5.48-2.473l-.187 2.994Zm3.545 1.6a5.5 5.5 0 0 1 1.6 3.546l2.994-.188a8.5 8.5 0 0 0-2.473-5.48l-2.12 2.122Zm1.6 3.546a5.5 5.5 0 0 1-1.146 3.717l2.37 1.84a8.5 8.5 0 0 0 1.77-5.745l-2.994.188Zm-1.146 3.717a5.5 5.5 0 0 1-3.318 2.03l.56 2.947a8.5 8.5 0 0 0 5.128-3.137l-2.37-1.84Zm-3.318 2.03a5.5 5.5 0 0 1-3.831-.674l-1.53 2.58a8.5 8.5 0 0 0 5.92 1.041l-.559-2.947Zm-5.008-.826-2.42.691.825 2.885 2.419-.691-.824-2.885Zm-2.42.691a.916.916 0 0 1 .482-.006l-.752 2.904c.36.093.738.089 1.095-.013l-.824-2.885Zm.482-.006a.916.916 0 0 1 .419.24l-2.122 2.12c.263.263.591.45.951.544l.752-2.904Zm.419.24c.115.115.198.26.239.417l-2.904.753c.093.36.28.688.543.95l2.122-2.12Zm.239.417a.917.917 0 0 1-.006.482l-2.885-.824a2.083 2.083 0 0 0-.013 1.095l2.904-.753Zm-.006.482.69-2.419-2.884-.824-.69 2.419 2.884.824Z"
      mask="url(#a)"
    />
    <path
      fill="#264382"
      d="M16.935 19.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615ZM13.433 19.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615ZM20.435 19.74a.808.808 0 1 0 0-1.615.808.808 0 0 0 0 1.615Z"
    />
    <circle cx="22" cy="13" r="4" fill="#fff" />
    <circle cx="22" cy="13" r="2" fill="#EA5400" />
  </svg>
)

export const ClientUnreadMsgIcon = (props) => (
  <Icon component={ClientUnreadMsgSvgIcon} {...props} />
)

const ClientEditSvgIcon = () => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      opacity="0.1"
      cx="18.9023"
      cy="17.9999"
      rx="18"
      ry="17.9999"
      fill="#75879D"
    />
    <path
      d="M17.4937 21.0452L24.262 14.2953C24.4735 14.0843 24.5923 13.7982 24.5923 13.4999C24.5923 13.2016 24.4735 12.9155 24.262 12.7046L23.134 11.5796C22.9224 11.3687 22.6356 11.2502 22.3365 11.2502C22.0373 11.2502 21.7505 11.3687 21.5389 11.5796L14.7706 18.3295C14.6846 18.415 14.613 18.5138 14.5586 18.622L13.6426 22.1702L17.2004 21.2624C17.3094 21.2064 17.4084 21.133 17.4937 21.0452Z"
      fill="#264382"
    />
    <path
      d="M25.1562 23.6247H12.7476C12.598 23.6247 12.4546 23.684 12.3488 23.7894C12.243 23.8949 12.1836 24.038 12.1836 24.1872C12.1836 24.3364 12.243 24.4794 12.3488 24.5849C12.4546 24.6904 12.598 24.7497 12.7476 24.7497H25.1562C25.3057 24.7497 25.4492 24.6904 25.555 24.5849C25.6608 24.4794 25.7202 24.3364 25.7202 24.1872C25.7202 24.038 25.6608 23.8949 25.555 23.7894C25.4492 23.684 25.3057 23.6247 25.1562 23.6247Z"
      fill="#264382"
    />
  </svg>
)

export const ClientEditIcon = (props) => (
  <Icon component={ClientEditSvgIcon} {...props} />
)

const ClientXSvgIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      opacity="0.1"
      cx="18"
      cy="17.9999"
      rx="18"
      ry="17.9999"
      fill="#75879D"
    />
    <path
      d="M22.7066 13.4178C22.5191 13.2303 22.2648 13.125 21.9996 13.125C21.7344 13.125 21.4801 13.2303 21.2926 13.4178L17.9996 16.7108L14.7066 13.4178C14.518 13.2356 14.2654 13.1348 14.0032 13.1371C13.741 13.1394 13.4902 13.2446 13.3048 13.43C13.1194 13.6154 13.0142 13.8662 13.0119 14.1284C13.0096 14.3906 13.1104 14.6432 13.2926 14.8318L16.5856 18.1248L13.2926 21.4178C13.1971 21.51 13.1209 21.6204 13.0685 21.7424C13.0161 21.8644 12.9885 21.9956 12.9873 22.1284C12.9862 22.2612 13.0115 22.3928 13.0618 22.5157C13.1121 22.6386 13.1863 22.7503 13.2802 22.8442C13.3741 22.9381 13.4857 23.0123 13.6086 23.0626C13.7315 23.1129 13.8632 23.1382 13.996 23.137C14.1288 23.1359 14.26 23.1083 14.382 23.0559C14.504 23.0035 14.6143 22.9273 14.7066 22.8318L17.9996 19.5388L21.2926 22.8318C21.4812 23.0139 21.7338 23.1147 21.996 23.1125C22.2582 23.1102 22.509 23.005 22.6944 22.8196C22.8798 22.6342 22.985 22.3834 22.9873 22.1212C22.9895 21.859 22.8888 21.6064 22.7066 21.4178L19.4136 18.1248L22.7066 14.8318C22.8941 14.6443 22.9994 14.39 22.9994 14.1248C22.9994 13.8596 22.8941 13.6053 22.7066 13.4178Z"
      fill="#264382"
    />
  </svg>
)

export const ClientXIcon = (props) => (
  <Icon component={ClientXSvgIcon} {...props} />
)
